var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "desktop-client", style: { "--app-scale": _vm.appScale } },
    [
      _c(
        "div",
        {
          ref: "inner",
          staticClass: "desktop-client__inner",
          class: { "desktop-client__inner--single": _vm.isSinglePane },
          style: { zoom: _vm.appScale },
        },
        [
          _c("DesktopHeader", {
            staticClass: "desktop-client__header",
            attrs: { "single-only": _vm.hasSingleArena },
            scopedSlots: _vm._u([
              {
                key: "ticker",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        ref: "notifications",
                        staticClass: "desktop-client__notifications",
                      },
                      [
                        _c("Notifications", {
                          attrs: {
                            popover: "",
                            "active-popover": _vm.tickerPopover
                              ? _vm.tickerPopover.type
                              : "",
                          },
                          on: { "toggle-popover": _vm.toggleTickerPopover },
                        }),
                        _vm.tickerPopover &&
                        _vm.tickerPopover.type === "notification"
                          ? _c("NotificationPopover", {
                              attrs: {
                                left: _vm.TICKER_POPOVER_LEFT,
                                "arrow-left":
                                  _vm.tickerPopover.anchor -
                                  _vm.TICKER_POPOVER_LEFT,
                              },
                              on: {
                                close: function ($event) {
                                  _vm.tickerPopover = null
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.tickerPopover &&
                        _vm.tickerPopover.type === "schedule"
                          ? _c("SchedulePopover", {
                              attrs: {
                                left: _vm.TICKER_POPOVER_LEFT,
                                "arrow-left":
                                  _vm.tickerPopover.anchor -
                                  _vm.TICKER_POPOVER_LEFT,
                              },
                              on: {
                                close: function ($event) {
                                  _vm.tickerPopover = null
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "desktop-client__body" },
            [
              _c("SideRail", { staticClass: "desktop-client__rail" }),
              _c(
                "main",
                { staticClass: "desktop-client__panes" },
                [
                  _vm._l(_vm.visiblePaneIds, function (paneId) {
                    return [
                      _vm.panes[paneId] &&
                      _vm.panes[paneId].product === "tai-xiu"
                        ? _c("TaiXiuPane", {
                            key: `${paneId}-tai-xiu`,
                            attrs: {
                              "pane-id": paneId,
                              "table-id": _vm.panes[paneId].id,
                              "arena-items": _vm.arenaItemsFor(paneId),
                              wide: _vm.isSinglePane,
                            },
                            on: {
                              "select-arena": function ($event) {
                                return _vm.selectArena(paneId, $event)
                              },
                            },
                          })
                        : _vm.panes[paneId]
                        ? _c("CockfightPane", {
                            key: `${paneId}-cockfight`,
                            attrs: {
                              "pane-id": paneId,
                              "arena-id": _vm.panes[paneId].id,
                              "arena-items": _vm.arenaItemsFor(paneId),
                              active: _vm.hasUncollectTicket,
                              wide: _vm.isSinglePane,
                            },
                            on: {
                              "select-arena": function ($event) {
                                return _vm.selectArena(paneId, $event)
                              },
                              jackpot: _vm.openJackpot,
                              "jackpot-physical": _vm.openJackpotPhysical,
                            },
                          })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("MenuPopup", {
        attrs: {
          fixed: "",
          "top-inset": _vm.popupTopInset,
          "left-inset": _vm.popupLeftInset,
        },
      }),
      _c("JackpotPopups", {
        ref: "jackpotPopups",
        attrs: { "top-inset": _vm.popupTopInset, frame: _vm.appFrame },
      }),
      _c("BetErrorPopup"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }